import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { graphviz } from 'd3-graphviz';
import { ComponentSync, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { generateReferencablesGraphString } from './utils.js';
import './Graph_Referencables.scss';
import { ModuleFE_Referencable } from '../ModuleFE_Referencable.js';
import { Component_ReferencableViewer } from '../Component_ReferencableViewer/Component_ReferencableViewer.js';
import { exists } from '@nu-art/ts-common';
import { DropDown_Referencable } from '../ui-components.js';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import React from 'react';
const graphEngines = ['twopi', 'dot'];
const engineLabelMap = {
    twopi: 'Circular (twopi)',
    dot: 'Tree (dot)',
};
export class Graph_Referencables extends ComponentSync {
    graphContainerRef = React.createRef();
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.graphEngine ??= 'twopi';
        state.graphString = generateReferencablesGraphString();
        return state;
    }
    componentDidMount() {
        this.renderGraph();
    }
    componentDidUpdate() {
        this.renderGraph();
        this.markElements();
    }
    // ######################## Logic ########################
    onGraphClick = (e) => {
        const target = e.target;
        if (target.tagName.toLowerCase() === 'svg')
            return this.setState({ selectedReferencable: undefined });
        const nearestGroup = target.closest('g');
        if (!nearestGroup)
            return;
        const referencable = ModuleFE_Referencable.cache.unique(nearestGroup.id);
        if (!referencable)
            return;
        this.setState({ selectedReferencable: referencable });
    };
    onGraphMouseMove = (e) => {
        const target = e.target;
        //Clear hovered referencable
        if (target.tagName.toLowerCase() === 'svg' && exists(this.state.hoveredReferencable))
            return this.setState({ hoveredReferencable: undefined });
        const nearestGroup = target.closest('g');
        if (!nearestGroup)
            return;
        if (nearestGroup.id === this.state.hoveredReferencable?._id)
            return;
        const referencable = ModuleFE_Referencable.cache.unique(nearestGroup.id);
        if (!referencable)
            return;
        this.setState({ hoveredReferencable: referencable });
    };
    markElements = () => {
        const selectedId = this.state.selectedReferencable?._id;
        const container = this.graphContainerRef.current;
        if (!selectedId || !container)
            return;
        //Mark selected node
        const id = CSS.escape(selectedId);
        const selectedRefNode = container.querySelector(`g.node#${id}`);
        selectedRefNode?.classList.add('selected');
    };
    // ######################## Render ########################
    render() {
        const hoveredRef = this.state.selectedReferencable?._id === this.state.hoveredReferencable?._id
            ? undefined
            : this.state.hoveredReferencable;
        return _jsxs("div", { id: 'referencables-graph', children: [_jsx("div", { className: 'referencables-graph__graph-container', ref: this.graphContainerRef, onClick: this.onGraphClick, onMouseMove: this.onGraphMouseMove }), _jsxs("div", { className: 'referencables-graph__util-layer', children: [this.render_GraphEngineSelector(), this.render_SelectedReferencable(), _jsx(Component_ReferencableViewer, { referencable: this.state.selectedReferencable, className: 'selected', allowMenu: true }), _jsx(Component_ReferencableViewer, { referencable: hoveredRef, className: 'hovered' })] })] });
    }
    renderGraph = () => {
        if (!this.state.graphString)
            return;
        const container = this.graphContainerRef.current;
        if (!container)
            return;
        const rect = container.getBoundingClientRect();
        graphviz(container, {
            useWorker: false,
            width: rect.width,
            height: rect.height,
            engine: this.state.graphEngine,
            zoomScaleExtent: [0.2, 5],
        })
            .renderDot(this.state.graphString);
    };
    render_GraphEngineSelector = () => {
        const adapter = SimpleListAdapter(graphEngines, i => _jsx(_Fragment, { children: engineLabelMap[i.item] ?? i.item }));
        return _jsx(TS_DropDown, { className: 'referencables-graph__engine-selector', adapter: adapter, selected: this.state.graphEngine, onSelected: graphEngine => this.setState({ graphEngine }), caret: DropDown_DefaultCaret });
    };
    render_SelectedReferencable = () => {
        return _jsx(DropDown_Referencable.selectable, { selected: this.state.selectedReferencable, className: 'referencables-graph__ref-selector', onSelected: ref => this.setState({ selectedReferencable: ref }), canUnselect: true, caret: DropDown_DefaultCaret });
    };
}
//# sourceMappingURL=Graph_Referencables.js.map